export const STYLES_WIDTH_FULL = 12;
export const STYLES_WIDTH_HALF = 6;
